/// <reference path="../../_ext/Editors/EditorDialogBase.ts" />
namespace TabAurous.Production {

    @Serenity.Decorators.registerClass()
    export class JobWorkIssueBOMDialog extends _Ext.MFGTransBOMEditorDialog<JobWorkIssueBOMRow> {
        protected getFormKey() { return JobWorkIssueBOMForm.formKey; }
    //    protected getIdProperty() { return JobWorkIssueBOMRow.idProperty; }
        protected getLocalTextPrefix() { return JobWorkIssueBOMRow.localTextPrefix; }
        protected getNameProperty() { return JobWorkIssueBOMRow.nameProperty; }
        //protected getService() { return JobWorkIssueBOMService.baseUrl; }
        //protected getDeletePermission() { return JobWorkIssueBOMRow.deletePermission; }
        //protected getInsertPermission() { return JobWorkIssueBOMRow.insertPermission; }
        //protected getUpdatePermission() { return JobWorkIssueBOMRow.updatePermission; }

        protected form = new JobWorkIssueBOMForm(this.idPrefix);

    }
}